import { Component, forwardRef, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-d-select',
  templateUrl: './d-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DSelectComponent),
      multi: true
    }
  ]
})
export class DSelectComponent extends DynamicComponentBase {
  static KEY = 'd-select';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {
    if (typeof config.showSearch !== 'boolean') {
      config.showSearch = true;
    }
    if (typeof config.allowClear !== 'boolean') {
      config.allowClear = true;
    }
    if (!Array.isArray(config.dataSource)) {
      config.dataSource = [
        {
          value: '1',
          label: '选项1'
        },
        {
          value: '2',
          label: '选项2'
        },
        {
          value: '3',
          label: '选项3'
        }
      ];
    }
  }
}
